// RepositoryFilter
const CONST_FILTER_EQUALS = 'EQUALS';
const CONST_FILTER_LIKE = 'LIKE';
const CONST_FILTER_GREATER = 'GREATER';
const CONST_FILTER_LESSER = 'LESSER';
const CONST_FILTER_GREATEREQUAL = 'GREATEREQUAL';
const CONST_FILTER_LESSEREQUAL = 'LESSEREQUAL';

const CONST_INT = 'int';
const CONST_LONG = 'Long';
const CONST_BOOLEAN = 'Boolean';
const CONST_STRING = 'String';
const CONST_DATE = 'Date';
const CONST_TIME = 'Time';

const CONST_ASC = 'ASC';
const CONST_DESC = 'DESC';

const CONST_FNACIONAL = 'FNACIONAL';
const CONST_FREGIONAL = 'FREGIONAL';
const CONST_FLOCAL = 'FLOCAL';
const CONST_FOTROS = 'FOTROS';

export default {
  // RepositoryFilter
  CONST_FILTER_EQUALS: CONST_FILTER_EQUALS,
  CONST_FILTER_LIKE: CONST_FILTER_LIKE,
  CONST_FILTER_GREATER: CONST_FILTER_GREATER,
  CONST_FILTER_LESSER: CONST_FILTER_LESSER,
  CONST_FILTER_GREATEREQUAL: CONST_FILTER_GREATEREQUAL,
  CONST_FILTER_LESSEREQUAL: CONST_FILTER_LESSEREQUAL,

  CONST_INT: CONST_INT,
  CONST_LONG: CONST_LONG,
  CONST_BOOLEAN: CONST_BOOLEAN,
  CONST_STRING: CONST_STRING,
  CONST_DATE: CONST_DATE,
  CONST_TIME: CONST_TIME,

  CONST_ASC: CONST_ASC,
  CONST_DESC: CONST_DESC,

  CONST_FNACIONAL: CONST_FNACIONAL,
  CONST_FREGIONAL: CONST_FREGIONAL,
  CONST_FLOCAL: CONST_FLOCAL,
  CONST_FOTROS: CONST_FOTROS
};
